
import { useRef } from 'react';
import { Link} from 'react-router-dom';
import useOutsideAlerter from '../../Hooks/useOutsideAlerter';
import './Sidebar.css';



const SideBar = () => {

    // const location = useLocation();
    const wrapperRef = useRef(null);

    const hideSidebar = () => {
        if(document.getElementById('sidebar').classList.contains('show')){
            document.getElementById('sidebar').classList.remove('show');
        }
    }

    useOutsideAlerter(wrapperRef, hideSidebar);


    // useEffect(() => {

    //     let links = document.getElementsByClassName('sidebar_link');
    //     for(let link of links){
    //         if(link !== 'undefined'){
    //             link.classList.remove('active');
    //         }       
    //     }

    //     if(location.pathname === '/') {
    //         document.getElementById('sidebar_home').classList.add('active');
    //     }
    //     else if(location.pathname === '/collections'){
    //         document.getElementById('sidebar_collections').classList.add('active');
    //     }
    //     else if(location.pathname === '/uploadnft'){
    //         document.getElementById('sidebar_').classList.add('active');
    //     }
    //     else if(location.pathname === '/userprofile'){
    //         document.getElementById('sidebar_profile').classList.add('active');
    //     }
    //     else if(location.pathname === '/community'){
    //         document.getElementById('sidebar_community').classList.add('active');
    //     }
    //     else if(location.pathname === '/privacypolicy'){
    //         document.getElementById('sidebar_privacypolicy').classList.add('active');
    //     }
    //     else if(location.pathname === '/connectwallet'){
    //         document.getElementById('sidebar_connectwallet').classList.add('active');
    //     }
    //     else if(location.pathname === '/faq'){
    //         document.getElementById('sidebar_faq').classList.add('active');
    //     }

    //     if(document.getElementById('sidebar').classList.contains('show')){
    //        document.getElementById('sidebar').classList.remove('show');
    //     }
        
    // }, [location])

    return(
        <div ref = {wrapperRef} id = 'sidebar' className="lg:hidden pt-[3rem] z-[98] sidebar shadow-shadow3 translate-x-[-250px] lg:translate-x-0 lg:left-0 fixed w-[250px] h-[100vh] bg-white dark:bg-dark-nav-bg ">
            
            <ul className="flex flex-col p-3 text-lg dark:text-white">

                <li >
                    <Link to = '/' onClick = {hideSidebar} className={`p-4 sidebar_link`} id = 'sidebar_home'>
                        Home
                    </Link>
                </li>

                <li >
                    <Link to = '/collections' onClick = {hideSidebar}  className={`p-4 sidebar_link`} id = 'sidebar_collections'>
                        Collections
                    </Link>
                </li>

                <li >
                    <Link to = '/activity' onClick = {hideSidebar}  className={`p-4 sidebar_link`} id = 'sidebar_profile'>
                        Activity
                    </Link>
                </li>

                <li>
                    <Link to = '/rankings' onClick = {hideSidebar} className={`p-4 sidebar_link`} id = 'sidebar_uploadnft'>
                        Rankings
                    </Link>
                </li>

                <li className='sidebar_collapse'>

                    <input type = 'checkbox' id = 'sidebar_community_check' className='hidden'/>
                    <label for = 'sidebar_community_check' className={`p-4 sidebar_link`} id = 'sidebar_community'>
                            Creator
                    </label>
                    <div className='pl-7 sidebar_socials py-3'>
                        <ul>
                            <li><a href = 'http://airtable.com/' rel="noreferrer" target = '_blank' className='hover:underline border-0'>Apply for Listing</a></li>
                            <li><a href = 'http://airtable.com/' rel="noreferrer" target = '_blank' className='hover:underline border-0'>Apply for Launchpad</a></li>
                        </ul>
                    </div>
                </li>

                <li>
                    <Link to = '/privacypolicy' onClick = {hideSidebar}  className={`p-4 sidebar_link`} id = 'sidebar_privacypolicy'>
                        Privacy Policy
                    </Link>
                </li>

                <li className='lg:hidden'>
                    <Link to = '/connectwallet' onClick = {hideSidebar}  className={`p-4 sidebar_link`} id = 'sidebar_connectwallet'>
                        Connect Wallet
                    </Link>
                </li>

                <li className='lg:hidden'>
                    <Link to = '/member/1' onClick = {hideSidebar}  className={`p-4 sidebar_link`} id = 'sidebar_faq'>
                        Profile
                    </Link>
                </li>

            </ul>

        </div>
    )
}

export default SideBar;
